import { render, staticRenderFns } from "./writeOffNakladnoy.vue?vue&type=template&id=9f48b920&scoped=true"
import script from "./writeOffNakladnoy.vue?vue&type=script&lang=js"
export * from "./writeOffNakladnoy.vue?vue&type=script&lang=js"
import style0 from "./writeOffNakladnoy.vue?vue&type=style&index=0&id=9f48b920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f48b920",
  null
  
)

export default component.exports